export default __webpack_public_path__ + "static/media/wood-visuals-in-a-printed-film.9decd917.svg";